// const BaseUrl = "http://localhost:5001/exsportia-dev/us-central1/";
const BaseUrl = "https://us-central1-exsportia-dev.cloudfunctions.net/";

export async function postData(url = '', data = {}) {
    const response = await fetch(`${BaseUrl}${url}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

    return await response.json();
}

export async function checkAccessKey(url = '', data = {}) {
    const response = await fetch(`${BaseUrl}${url}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

    return await response.json();
}

export async function createAccessKeyRequest(url = '', data = {}) {
    const response = await fetch(`${BaseUrl}${url}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

    return await response.json();
}

export async function connectRequest(url = '', data = {}) {
    const response = await fetch(`${BaseUrl}${url}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

    return await response.json();
}

export async function deleteMedia (url = '', data = {}) {
    const response = await fetch(`${BaseUrl}${url}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

    return await response.json();
}

export async function sendData(url = '', data) {
    const formData  = new FormData();

    for(const name in data) {
        formData.append("media", data[name]);
    }

    const response = await fetch(`${BaseUrl}${url}`, {
        method: 'POST',
        body: formData
    });
    return await response.json()
}
